import { Person2Rounded as Person2RoundedIcon } from '@mui/icons-material';
import { CalendarMonthRounded as CalendarMonthRoundedIcon } from '@mui/icons-material';
import { AttachMoneyRounded as AttachMoneyRoundedIcon }  from '@mui/icons-material';
import { DealInformation } from '../types';

interface Props {
    deal: DealInformation;
}

export function InformationSection({ deal }: Props) {
    return (
        <div>
            <div className="flex justify-between font-semibold pb-2">
                <div className="flex gap-x-1 items-center">
                    <Person2RoundedIcon sx={{ height: 20, width: 20 }}/>
                    <p>Prospectador</p>
                </div>
                <p className="text-gray-600">{deal.prospectador}</p>
            </div>

            <div className="flex justify-between font-semibold pb-2">
                <div className="flex gap-x-1 items-center">
                    <CalendarMonthRoundedIcon sx={{ height: 20, width: 20 }}/>
                    <p>Fecha de inicio</p>
                </div>
                <p className="text-gray-600">{deal.fechaInicio}</p>
            </div>

            <div className="flex justify-between font-semibold pb-2">
                <div className="flex gap-x-1 items-center">
                    <CalendarMonthRoundedIcon sx={{ height: 20, width: 20 }}/>
                    <p>Fecha de fin</p>
                </div>
                <p className="text-gray-600">{deal.fechaFin}</p>
            </div>

            <p className="font-semibold text-lg py-3">Información de las visitas</p>

            <div className="flex justify-between font-semibold pb-2 items-center">
                <div className="flex gap-x-1 items-center">
                    <AttachMoneyRoundedIcon sx={{ height: 20, width: 20 }}/>
                    <p>Intenciones vendidas</p>
                </div>
                <p className="text-gray-600">{deal.intencionesVendidas}</p>
            </div>
        </div>
    );
}
